export default __webpack_public_path__ + "static/media/Snd3.737f14ee.mp3";